// 引入axios
import axios from 'axios'
import store from './store'
import router from './router'
import { Message } from 'element-ui';

// 获取当前ip:
let curBaseUrl = store.state.curIp.baseUrl

if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = curBaseUrl;
  // axios.defaults.baseURL = 'http://172.16.9.168:18089/';
  //#region
  //axios.defaults.baseURL = 'http://192.168.16.53:8088/ptcloud/';
  // axios.defaults.baseURL = 'http://192.168.16.53:8088/srcloud/';
  // axios.defaults.baseURL = 'http://192.168.16.50:8083/srcloud/';
  //axios.defaults.baseURL = 'http://192.168.17.44:9104/';
  // axios.defaults.baseURL = 'http://127.0.0.1:8080/';
  // axios.defaults.baseURL = 'http://192.168.16.50:8078/handancloud/';
  // 測試環境
  // axios.defaults.baseURL = 'http://122.112.173.252:18089/';
  // 胡帅
  // axios.defaults.baseURL = 'http://172.16.6.50:8082/';
  //  #endregion;
}
else if (process.env.NODE_ENV == 'debug') {
  axios.defaults.baseURL = '';
}
else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = curBaseUrl;
  //#region
  // axios.defaults.baseURL = 'http://10.10.3.4:8089/';

  // axios.defaults.baseURL = 'http://192.168.16.50:8078/handancloud/';
  // axios.defaults.baseURL = 'http://192.168.16.53:8088/srcloud/';
  // 測試環境
  // axios.defaults.baseURL = 'http://122.112.173.252:18089/';
  // axios.defaults.baseURL = 'http://172.16.6.50:8082/';
  //  #endregion;
}
axios.defaults.timeout = 50000; //设置请求时间
// 响应拦截器
//请求拦截
axios.interceptors.request.use(
  config=>{
      // if(store.state.token){
      //     config.headers.token=store.state.token
      // }
      console.log('url:'+config.baseURL+config.url)
      console.log({'ajax参数':config.data})
      if(JSON.stringify(config.data)!='{}'){
        config.data = JSON.stringify(config.data);
      }
      config.headers = {
        'Content-Type':'application/x-www-form-urlencoded'
        //'Content-Type':'application/json' //设置跨域头部,虽然很多浏览器默认都是使用json传数据，但咱要考虑IE浏览器。
      }
      console.log(config)
      return config
  }
)
axios.interceptors.response.use(
  response => {
      //如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
      //否则的话抛出错误
      if (response.status === 200) {
          console.log(response.data)
          // if(response.data.status==2){
          //   Message.error({message:response.data.msg,offset:400})
          // }else if(response.data.status==3){
          //   Message.error({message:response.data.msg,offset:400})
          //   router.go(-1)
          // }else if(response.data.status==4){

          // }else if(response.data.status==5){

          // }
      } else {
        // Message.error({message:'请求错误：'+error.response.status,offset:400})
      }
      return response.data;
  },
  error => {
      console.log(error.response)
      let that=this
      if (error.response) {
        // Message.error({message:'请求错误：'+error.response.status,offset:400})
      }else{
        // Message.error({message:'连接服务端失败...',offset:400})
      }
      return Promise.reject(error.response)
  }
);
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
*/
export function fetch(url,params={}){
    return new Promise((resolve,reject) => {
      axios.get(url,{
        params:params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
    })
  }
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function post(url,data = {}){
   return new Promise((resolve,reject) => {
     axios.post(url,data).then(response => {
        resolve(response.data);
        },err => {
        reject(err)
        })
    })
 }
